// ===================================================
// GAM Command Center — Text-to-Record storage bridge
// ===================================================
//
// No schema, no rendering — just a storage slot. It exists so the slash
// command menu (which only receives {editor, range}, no host closures — see
// slash-command-items.ts) can reach the host's onCreateFromText callback the
// same way ObjectRef's onRequestInsert bridges the "Object Reference" entry.
// The floating toolbar's "משימה" button does NOT need this: it renders with
// editor/aiTextAction already as direct props, so it calls onCreateFromText
// straight from FloatingToolbar.tsx.

import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Storage {
    textToRecord: {
      /** Host wires this in a useEffect (mirrors objectRef.onRequestInsert). */
      onCreateTask: null | (() => void);
    };
  }
}

export const TextToRecordBridge = Extension.create({
  name: 'textToRecord',

  addStorage() {
    return {
      onCreateTask: null as null | (() => void),
    };
  },
});
